import { render, staticRenderFns } from "./board_write.vue?vue&type=template&id=32ab9413&scoped=true&"
import script from "./board_write.vue?vue&type=script&lang=js&"
export * from "./board_write.vue?vue&type=script&lang=js&"
import style0 from "./board_write.vue?vue&type=style&index=0&id=32ab9413&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ab9413",
  null
  
)

export default component.exports